import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
  Box,
  Alert
} from '@mui/material';
import {
  GetApp as InstallIcon,
  Close as CloseIcon,
  Android as AndroidIcon,
  Apple as AppleIcon,
  DesktopWindows as DesktopIcon
} from '@mui/icons-material';

const PWAPrompt = () => {
  const [isSupported, setIsSupported] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if the app is already installed
    const isAppInstalled = window.matchMedia('(display-mode: standalone)').matches;
    setIsInstalled(isAppInstalled);

    // Check if the browser supports PWA installation
    const isSupported = 'BeforeInstallPromptEvent' in window;
    setIsSupported(isSupported && !isAppInstalled);

    // Listen for beforeinstallprompt event
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // setIsOpen(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setIsInstalled(true);
      }
      setIsOpen(false);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  if (!isSupported || isInstalled) {
    // return <Alert severity="info" sx={{ position: 'fixed', bottom: 16, right: 16 }}>
    //   {/* This app is already installed or not supported for installation. */}
    //   {isInstalled ? 'This app is already installed.' : 'This browser does not support PWA installation.'}
    // </Alert>;
    return null;
  }

  return (
    <Box>
      {/* Floating install button */}
      <Tooltip title="Install App" arrow>
        <IconButton
          color="primary"
          aria-label="Install App"
          onClick={() => handleInstallClick()}
          // onClick={() => setIsOpen(true)}
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            backgroundColor: 'background.paper',
            boxShadow: 3,
            '&:hover': {
              backgroundColor: 'action.hover'
            }
          }}
        >
          <InstallIcon fontSize="large" />
        </IconButton>
      </Tooltip>

      {/* Installation dialog */}
      {/* <Dialog open={isOpen} onClose={handleClose}>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Install App
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Install this application on your device for a better experience:
          </DialogContentText>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <AndroidIcon fontSize="large" />
              <span>Android: Tap "Install" in the browser menu</span>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <AppleIcon fontSize="large" />
              <span>iOS: Tap the Share icon and select "Add to Home Screen"</span>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <DesktopIcon fontSize="large" />
              <span>Desktop: Click "Install" in the address bar</span>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<InstallIcon />}
            onClick={handleInstallClick}
            size="large"
            sx={{ px: 4 }}
          >
            Install Now
          </Button>
        </DialogActions>
      </Dialog> */}
    </Box>
  );
};

export default PWAPrompt;